<template>
  <section v-if="hasPermissions(['QC-Inspection-Surveys Read'])" class="view">
        <Breadcrumb :breadcrumb="breadcrumb"/>
        <h1 class="view__title title--1">
            {{ title_page }}
        </h1>
        <div class="view__description">
            <p class="view__description__text"
                v-html='``'
            />
        </div>
        <div class="row mb-0 no-gutters templates__grid" v-if="hasPermissions(['QC-Inspection-Surveys Read'])">
            <div class="templates__grid__tabs" style="max-width: 300px">
                <div id="nav-tab" role="tablist" class="nav nav-tabs templates__grid__item d-flex justify-content-between">
                    <a class="templates__grid__tabs__item active rounded pl-0" id="nav-home-tab" data-toggle="tab" href="#nav-home" role="tab" aria-controls="nav-home" aria-selected="true" v-html="'View Summary'" style="width: 50%;" @click="view_by_summary = true"/>
                    <a class="templates__grid__tabs__item rounded pl-0" id="nav-profile-tab" data-toggle="tab" href="#nav-profile" role="tab" aria-controls="nav-profile" aria-selected="false" v-html="'View Individual Responses'" style="width: 50%;" @click="view_by_summary = false"/>
                </div>
            </div>
        </div>
        <div class="tab-content" v-show="view_by_summary && survey_questions.length" style="margin-top:40px;">
            <div class="tab-pane fade active show" id="listation">
                <div class="row mb-0 no-gutters">
                    <div class="col-lg-12">
                        <div class="row">
                            <div class="col-lg-12">
                                <div class="w-100 table-responsive overflow-y--1" style="min-height:750px;">
                                    <table class="table">
                                        <thead style="background-color: #f1f1f1;">
                                            <tr>
                                                <th v-for="(item, i) in table_headers" :key="i" scope="col" v-html="item.name"/>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(item, i) in survey_questions" :key="i">
                                                <td v-html="i+1"/>
                                                <td v-html="item.question"/>
                                                <td style="padding-left:0px;">

                                                    <div class="d-inline-block" v-if="item.response_type === 1">
                                                        <table>
                                                            <thead>
                                                                <tr>
                                                                    <th scope="col" v-html="''" style="padding:6px;"/>
                                                                    <th scope="col" v-for="(value, j) in item.answers_data" :key="j" v-html="value.answer_text" style="padding:6px;"/>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr>
                                                                    <th scope="col" v-html="'Count:'"/>
                                                                    <td v-for="(value, j) in item.answers_data" :key="j" v-html="answer_response(item.id, value.id)"/>
                                                                </tr>
                                                                <tr>
                                                                    <th scope="col" v-html="'Percentage:'"/>
                                                                    <td v-for="(value, j) in item.answers_data" :key="j" v-html="`${percentage_answer_response(item.id, value.id)}%`"/>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>

                                                    <div class="d-inline-block" v-else-if="item.response_type === 2">
                                                        <table>
                                                            <thead>
                                                                <tr>
                                                                    <th scope="col" v-html="''" style="padding:6px;"/>
                                                                    <th scope="col" v-html="'Yes'" style="padding:6px;"/>
                                                                    <th scope="col" v-html="'No'" style="padding:6px;"/>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr>
                                                                    <th scope="col" v-html="'Count:'"/>
                                                                    <td v-html="count_response(item.id, true)"/>
                                                                    <td v-html="count_response(item.id)"/>
                                                                </tr>
                                                                <tr>
                                                                    <th scope="col" v-html="'Percentage:'"/>
                                                                    <td v-html="`${percentage_response(item.id, true)}%`"/>
                                                                    <td v-html="`${percentage_response(item.id)}%`"/>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>

                                                    <div class="formdynamic__item__field" v-if="item.response_type === 3" style="overflow-y: scroll;">

                                                        <div v-if="comment_responses(item.id).length">
                                                            <div class="col-lg-12" v-for="(item, i) in comment_responses(item.id)" :key="i" style="padding:5px;">
                                                                <div class="row mb-0 no-gutters h-100">
                                                                    <div class="col-12 card cardList hoverable">
                                                                        <div class="card-content h-100">
                                                                            <div class="card-title">
                                                                                <div class="row mb-0 no-gutters">
                                                                                    <div class="col-12">
                                                                                        <p class="card-content__text" v-html="item.comment" />
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div v-else>
                                                            <p>No comments available</p>
                                                        </div>
                                                    </div>

                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="tab-content" v-show="!view_by_summary">
            <div class="tab-pane fade active show mt-4" id="listation">
                <div class="row mb-0 no-gutters">
                    <div class="col-lg-12">
                        <v-card>
                            <DinamicTable
                                :headers="table_headers_responses"
                                :items="individual_responses"
                                :search="''"
                                :checkable="false"
                                :link="'/qc-individual-response/'"
                                :updateable="false"
                            />
                        </v-card>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal__buttons d-md-flex justify-content-md-end" style="margin-top:0px;">
            <a href="/qc-surveys" class="modal__buttons__item" v-html="`Go Back`"/>
        </div>

        <WaitingModal/>

        <SuccessfullModal
            :message="`Survey completion success`"
            :second_message="`Thanks for completing the survey! Your responses have been recorded.`"
            @ConfirmSuccess="dashboardReturn()"
        />

    </section>
</template>

<script>

import Breadcrumb           from    '@/components/BreadcrumbComponent/Breadcrumb'
import WaitingModal         from    '@/components/WaitingModal'
import SuccessfullModal     from    '@/components/SuccessfullModal'
import Resources            from    './resources'
import DinamicTable         from    '@/components/DinamicTable'
import 'vuetify/dist/vuetify.min.css'

import { Notyf }            from    'notyf';
import 'notyf/notyf.min.css'; // for React and Vue
const notyf = new Notyf({
    duration: 8000,
});

export default {

    name: 'Survey',

    components: {
        DinamicTable,
        Breadcrumb,
        WaitingModal,
        SuccessfullModal,
    },
    
    data() 
    {
        return {
            notyf,
            user: this.get_user(),
            child_href: '/qc-surveys-detail/',
            title_page: 'Survey Test - Responses',
            
            rest_api: `surveys/${JSON.stringify({
                responses: true,
                survey_id: this.$route.params.id,
            })}`,

            responses: [],
            table_headers: Resources.table_headers,
            table_headers_responses: Resources.table_headers_responses,
            breadcrumb: Resources.breadcrumb,
            single_select: false,
            table_selection: [],
            search: '',
            global_index: '',
            single_object: {},
            survey_questions: [],
            array_options: {},
            select_ids: [],
            view_by_summary: true,
            individual_responses: [],
            boolean_data: [
                {
                    id: true,
                    name: 'Yes',
                },
                {
                    id: false,
                    name: 'No',
                },
            ],
        }
    },

    methods: 
    {
        percentage_answer_response(survey_question_id, survey_answer_id)
        {
            let single_count = this.responses.filter(item => item.survey_question_id === survey_question_id && item.survey_answer_id === survey_answer_id).length
            let total_count = this.responses.filter(item => item.survey_question_id === survey_question_id).length
            let results = single_count / total_count
            let final_result = results * 100
            return !isNaN(final_result) ? parseInt(final_result) : 0
        },

        answer_response(survey_question_id, survey_answer_id)
        {
            return this.responses.filter(item => item.survey_question_id === survey_question_id && item.survey_answer_id === survey_answer_id).length
        },

        percentage_response(survey_question_id, boolean = false)
        {
            let single_count = this.responses.filter(item => boolean ? item.survey_question_id === survey_question_id && item.boolean_field : item.survey_question_id === survey_question_id && !item.boolean_field).length
            let total = this.responses.filter(item => item.survey_question_id === survey_question_id).length
            let results = single_count / total
            let final_result = results * 100
            return !isNaN(final_result) ? parseInt(final_result) : 0
        },

        count_response(survey_question_id, boolean = false)
        {
            if(boolean)
            {
                return this.responses.filter(item => item.survey_question_id === survey_question_id && item.boolean_field).length
            }

            return this.responses.filter(item => item.survey_question_id === survey_question_id && !item.boolean_field).length
        },

        comment_responses(survey_question_id)
        {
            return this.responses.filter(item => item.survey_question_id === survey_question_id).map((item) => { return {'comment': item.comment_field} } )
        },

        dashboardReturn()
        {
            window.location.href = '/'
            return true
        },

        fill_data(data)
        {
            if(this.view_by_summary)
            {
                this.survey_questions = data.survey_questions
                this.responses = data.responses
            }
            else
            {
                this.individual_responses = data.associate_answers
            }
        },
    },

    async mounted()
    {
        if(this.hasPermissions(['QC-Inspection-Surveys Read']))
        {
            await this.api_request()
        }
        else
        {
            window.location.href = '/'
        }
    },

    computed:
    {
        selected()
        {
            const bool = this.survey_questions.filter(item => item.checked)
            return Boolean(bool.length)
        }
    },

    watch: {
        view_by_summary(val)
        {
            if(val)
            {
                this.rest_api = `surveys/${JSON.stringify({
                    responses: true,
                    survey_id: this.$route.params.id,
                })}`
            }
            else
            {
                this.rest_api = `surveys/${JSON.stringify({
                    user_responses: true,
                    survey_id: this.$route.params.id,
                })}`
            }

            this.api_request()
        }
    }
}

</script>